// API Configuration for PartyPlanner
// This file centralizes API endpoint configuration

// Development configuration
const DEV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

// Production configuration (update this when deploying)
const PROD_API_BASE_URL = 'https://your-production-server.com';

// Determine which API URL to use based on environment
const isDevelopment = process.env.NODE_ENV === 'development';

export const API_BASE_URL = isDevelopment ? DEV_API_BASE_URL : PROD_API_BASE_URL;

// API Endpoints
export const API_ENDPOINTS = {
  INVITATIONS: {
    SEND: `${API_BASE_URL}/api/invitations/send`,
    STATUS: (id) => `${API_BASE_URL}/api/invitations/status/${id}`,
    UPDATE_STATUS: (id) => `${API_BASE_URL}/api/invitations/status/${id}`,
  },
};

// Test function to verify API configuration
export const testApiConnection = async () => {
  try {
    console.log('Testing API connection to:', API_BASE_URL);
    const response = await fetch(`${API_BASE_URL}/`);
    if (response.ok) {
      const text = await response.text();
      console.log('✅ API connection successful:', text);
      return true;
    } else {
      console.error('❌ API connection failed:', response.status);
      return false;
    }
  } catch (error) {
    console.error('❌ API connection error:', error);
    return false;
  }
};

// Log configuration for debugging
console.log('API Configuration:', {
  NODE_ENV: process.env.NODE_ENV,
  API_BASE_URL,
  isDevelopment,
  endpoints: API_ENDPOINTS,
});
